import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { fetchClientCheckInDetailsAPI } from "../../api/clientCheckInAPI";

// Initial state for the client check-in details
const initialState = {
  clientCheckInData: {
    updatedDate: "",
    updatedDay: "",
    totalSubscriptionWeeks: 0,
    currentSubscriptionWeeks: 0,
    weight: 0,
    targetWeight: 0,
    progressPictures: {
      firstCheckInFrontImage: null,
      latestCheckInFrontImage: null,
      previousCheckInFrontImage: null,
      firstCheckInSideImage: null,
      latestCheckInSideImage: null,
      previousCheckInSideImage: null,
      firstCheckInBackImage: null,
      latestCheckInBackImage: null,
      previousCheckInBackImage: null,
    },
    energyLevel: "",
    mood: "",
    digestion: "",
    workoutPlanUse: "",
    mealPlanUse: "",
    circumferences: {
      chest: 0,
      waist: 0,
      arm: 0,
      thigh: 0,
      shoulder: 0,
    },
    status: "",
    sleep: "",
    waterIntake: "",
    steps: "",
    previousMood: "",
    previousEnergyLevel: "",
  },
  loading: false,
  error: null,
};

// AsyncThunk to fetch client check-in details
export const fetchClientCheckInDetails = createAsyncThunk(
  "clientCheckIn/fetchDetails",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await fetchClientCheckInDetailsAPI(payload);
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

const clientCheckInSlice = createSlice({
  name: "clientCheckIn",
  initialState,
  reducers: {
    // You can add regular reducers here, if needed
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchClientCheckInDetails.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchClientCheckInDetails.fulfilled, (state, action) => {
        state.loading = false;
        state.error = null;

        const {
          checkInDetailsId,
          isread,
          updatedDate,
          updatedDay,
          totalSubscriptionWeeks,
          currentSubscriptionWeeks,
          weight,
          targetWeight,
          targetWeightdate,
          progressPictures,
          energyLevel,
          mood,
          digestion,
          workoutPlanUse,
          mealPlanUse,
          circumferences,
          status,
          sleep,
          waterIntake,
          steps,
          firstWeight,
          previousMood,
          previousEnergyLevel,
          previousDateCheckInEntry,
          currentDateCheckInEntry,
          nextDateCheckInEntry,
          previousDateCheckInDetailsId,
          nextDateCheckInDetailsId,
        } = action.payload;

        // Updating the state with the API response clientCheckInData
        state.clientCheckInData = {
          checkInDetailsId,
          isread,
          updatedDate,
          updatedDay,
          totalSubscriptionWeeks,
          currentSubscriptionWeeks,
          weight,
          targetWeight,
          targetWeightdate,
          progressPictures,
          energyLevel,
          mood,
          digestion,
          workoutPlanUse,
          mealPlanUse,
          circumferences,
          status,
          sleep,
          waterIntake,
          steps,
          firstWeight,
          previousMood,
          previousEnergyLevel,
          previousDateCheckInEntry,
          currentDateCheckInEntry,
          nextDateCheckInEntry,
          previousDateCheckInDetailsId,
          nextDateCheckInDetailsId,
        };
      })
      .addCase(fetchClientCheckInDetails.rejected, (state, action) => {
        state.loading = true;
        state.error =
          action.payload || "Failed to fetch client check-in details";
      });
  },
});

export default clientCheckInSlice.reducer;
